// extracted by mini-css-extract-plugin
export default {"root":"IlkYxEPYGzFsYAdbzBVh","block":"tEBoyBApxsQh1fCaKehA","icon":"Jrk9JqI06Pxq8V1I3dYg","wave-lines":"YQiQghcEpdbzTDtarp4b","label":"AVducDWxYc5qRL9DSap7"};